import texts from './lead-form.texts.json';
import yup from '@y2/yup';

export const validationSchema = yup.object({
  fullName: yup.string().heb().required(texts.fullNameMissing),
  phone: yup.string().phone().required(texts.phoneMissing),
  email: yup.string().email(texts.invalidEmail).required(texts.emailMissing),
});
